import { put } from "redux-saga/effects";
import { GetUserMetadataResponse } from "redmond";
import fetchUserMetadata from "../../../api/v0/user/fetchUserMetadata";
import { actions } from "../actions";

export const wishlistFtuxLocalStorageKey = "wishlistFtuxPopoverSeen";

export function* fetchHasSeenWishlistFtuxSaga(
  _: actions.IFetchHasSeenWishlistFtux
) {
  try {
    const isAlreadySeen =
      localStorage.getItem(wishlistFtuxLocalStorageKey) !== null;

    if (isAlreadySeen) {
      yield put(actions.setHasSeenWishlistFtux(true));
      return;
    }
    const res: GetUserMetadataResponse = yield fetchUserMetadata({
      keys: ["hasSeenWishlistsFtux"],
    });
    const hasSeenWishlistFtuxFromMetadata =
      !!res?.userMetadata?.hasSeenWishlistsFtux;

    if (hasSeenWishlistFtuxFromMetadata) {
      localStorage.setItem(wishlistFtuxLocalStorageKey, "true");
    }

    yield put(actions.setHasSeenWishlistFtux(hasSeenWishlistFtuxFromMetadata));
  } catch (e) {
    console.error(e);
  }
}
